'use strict';

var React = require('react');

var SvgMinimizeMajor = function SvgMinimizeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 17h8v-14h-14v8h-2v-8.5a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5h-8.5v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6a1 1 0 1 0-2 0v5a.997.997 0 0 0 1 1h5a1 1 0 1 0 0-2h-2.586l3.293-3.293a1 1 0 0 0-1.414-1.414l-3.293 3.293v-2.586zm-9 8.5a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-3z"
  }));
};

exports.SvgMinimizeMajor = SvgMinimizeMajor;
